import React from 'react';

import Input from '../Input';

const InputField = ({ name, formik, onBlur = null, ...props }) => (
  <Input
    name={name}
    value={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={onBlur ?? formik.handleBlur}
    error={formik?.touched[name] && formik?.errors[name]}
    {...props}
  />
);

export default InputField;
